import type { SelectFilterType } from "../components/SelectDataColumn/select-data-column.interface";

type FilterItem = {
  label: string | number | boolean;
  keyData: string;
  index: number;
  type: SelectFilterType;
};

const isEmptyTableValue = (value: unknown): boolean => {
  if (value === undefined || value === null) return true;
  if (typeof value === "string") {
    const trimmedValue = value.trim();
    return trimmedValue.length === 0 || trimmedValue === "--";
  }
  return false;
};

const toNumber = (v: number | string | null | undefined): number => {
  if (typeof v === "number") return v;
  if (typeof v === "string") {
    const norm = v.replace(/[^\d,-]/g, "").replace(",", ".");
    const n = Number(norm);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
};

const isPeticionadorManual = (row: Record<string, unknown>): boolean => {
  const vaProcesso = toNumber(row?.vaProcesso as number | string | null);
  const idPeca = (row?.idPeca as number | null) ?? 0;
  return vaProcesso <= 10000 && idPeca > 0;
};

const isEmptyValueByFilter = (
  row: Record<string, unknown>,
  keyData: string
): boolean => {
  return isEmptyTableValue(row[keyData]);
};

export function filterByColumn<T extends Record<string, unknown>>(
  data: T[],
  filters: FilterItem[]
): T[] {
  if (!filters?.length) return data;

  return data.filter((row) =>
    filters.every((f) => {
      if (f.type === "NO_DATA") {
        return isEmptyValueByFilter(row, f.keyData);
      }
      if (f.type === "VALUE_RANGE") {
        const val = Number(row[f.keyData] ?? 0);
        switch (f.label as number) {
          case 1: return val >= 0 && val <= 100;
          case 2: return val >= 100.01 && val <= 1000;
          case 3: return val >= 1000.01 && val <= 5000;
          case 4: return val >= 5000.01 && val <= 10000;
          case 5: return val >= 10000.01 && val <= 100000;
          case 6: return val >= 100000.01 && val <= 500000;
          case 7: return val > 500000;
          default: return true;
        }
      }
      if (f.type === "PETICIONADOR_MANUAL") {
        return Boolean(f.label) === isPeticionadorManual(row);
      }
      return row[f.keyData] === f.label;
    })
  );
}
